import { api, apiGet, apiPost } from './default'

const cpBase = API_PORTAL;
const mFunds = API_MFUNDS;

function checkCP(response) {
    return apiGet(cpBase + '/sso/validate');
}

function getTotalFunds() {
    return apiGet(mFunds + '/getTotals.php');
}

function getFundFamilies() {
    return apiGet(mFunds + '/getFamilies.php');
}

function logOut() {
    return apiPost(mFunds + '/logout.php');
}

function searchFunds(data) {
    let query = ``;
    if (data.identifier) { query += `&identifier=${ data.identifier }`}
    if (data.family) { query += `&family=${ data.family }`}
    if (data.txnfee) { query += `&txnfee=${ data.txnfee }`}
    if (data.itype) { query += `&itype=${ data.itype }`}
    if (data.page) { query += `&page=${ data.page }` }
    return api.get(`${mFunds}/index.php?residency=${ data.residency }${ query }`);
}

export default {
    checkCP,
    getTotalFunds,
    getFundFamilies,
    logOut,
    searchFunds
}
